import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuthorization } from './useAuthorization';

const AuthorizedLink = ({ action, children, ...rest }) => {
  const auth = useAuthorization();

  if (action && !auth.can(action)) {
    return null;
  }

  return <Link {...rest}>{children}</Link>;
};

AuthorizedLink.propTypes = {
  ...Link.propTypes,
  action: PropTypes.string.isRequired
};

export default AuthorizedLink;
